import axiosIns from "@/libs/axios";

class BotService {
    getMe() {
        return axiosIns.get(`/api/bot/get-me`)
    }
}

export default new BotService()
